/**
 * Formats the first-PAYG wallet notice for payment success and Billing.
 * Pack credits stay on the account; actor funding is optional later.
 */
import { SAAS_DEFAULT_ACTOR_ASSIGNMENT } from "../constants/saasPlansCatalog";

const fallbackAllocations = () =>
  (SAAS_DEFAULT_ACTOR_ASSIGNMENT.actorAllocations || []).map((row) => ({
    defaultKey: row.defaultKey,
    actorName: row.actorName,
    creditsAssigned: row.creditsAssigned,
  }));

export const normalizeDefaultActorAssignment = (raw) => {
  if (!raw || typeof raw !== "object") {
    return null;
  }
  const allocations = Array.isArray(raw.actorAllocations) && raw.actorAllocations.length
    ? raw.actorAllocations.map((row) => ({
      defaultKey: row?.defaultKey || "",
      actorName: String(row?.actorName || "").trim(),
      creditsAssigned: Number(row?.creditsAssigned) || 0,
    }))
    : fallbackAllocations();
  return {
    grantCredits: Number(raw.grantCredits) || SAAS_DEFAULT_ACTOR_ASSIGNMENT.grantCredits,
    settledFromPurchase: Boolean(raw.settledFromPurchase),
    debitApplied: raw.debitApplied,
    creditsDebited: raw.creditsDebited != null ? Number(raw.creditsDebited) : undefined,
    actorAllocations: allocations,
  };
};

export const formatDefaultActorAssignmentNotice = (assignment) => {
  const normalized = normalizeDefaultActorAssignment(assignment);
  if (!normalized?.settledFromPurchase) {
    return null;
  }
  return {
    title: "Credits are in your wallet",
    body: "This purchase was added to your account wallet. Actors were not funded automatically — assign credits from Actors whenever you want them for published personalized videos.",
  };
};
